import * as React from "react";

import { DataDeclarationFactory, ValidationFunctionsFactory } from "../../../../Forms/RawFormResources";
import { NidusEntry, NidusEntryData } from "../../../../../../Common/NidusClient/INidusClient";
import { DraftFullId } from "../../../../../../Common/CandyApiClient/Types/DraftFullId";
import { IContextualNidusClient } from "../../../../../../Common/NidusClient/ContextualNidusClient/IContextualNidusClient";
import { AutocalculationConfigurator } from "../../../../Forms/FormResources";

import { NidusEntryDataModalEditor } from "./NidusEntryDataModalEditor";

interface UpdateNidusEntryFormModalProps {
    editor: React.ReactNode;
    editorValidations: ValidationFunctionsFactory;
    kcXmlValidationConfigurator: AutocalculationConfigurator;
    editorDataDeclaration: DataDeclarationFactory;
    entryForUpdate: NidusEntry;
    title?: React.ReactNode;
    draftId: DraftFullId;
    keformsUrl: string;
    nidusClient: IContextualNidusClient;
    onItemUpdated: (nidusEntry: NidusEntry) => void;
    onClose: () => void;
    onError: () => void;
}

export function UpdateNidusEntryFormModal(props: UpdateNidusEntryFormModalProps): JSX.Element {
    const handleApplyData = async (newEntryData: NidusEntryData) => {
        try {
            await props.nidusClient.update(props.entryForUpdate.id, newEntryData);
            props.onItemUpdated({ id: props.entryForUpdate.id, data: newEntryData });
        } catch {
            props.onError();
        }
    };

    return (
        <NidusEntryDataModalEditor
            editor={props.editor}
            editorValidations={props.editorValidations}
            kcXmlValidationConfigurator={props.kcXmlValidationConfigurator}
            editorDataDeclaration={props.editorDataDeclaration}
            title={props.title ?? "Изменить значение в справочнике"}
            initialData={props.entryForUpdate.data}
            draftId={props.draftId}
            keformsUrl={props.keformsUrl}
            onApplyData={handleApplyData}
            onClose={props.onClose}
        />
    );
}
